<template>
<div class="card rounded-0 box-shadow-sm bg-light mx-auto pb-3 pb-sm-0" style="max-width: 700px">
  <div class="card-body">
    <div class="tab-content pt-2">
      <div class="tab-pane show active" id="detailTab" role="tabpanel"> 
        <i class="czi-check-circle h1 text-success mb-4"></i>
        <p class="text-center text-dark h5 mb-4 pb-2 mt-1">
          Die Bewertung deiner Küche ist auf dem Weg zu dir!
        </p>
        <p class="h6 text-center mb-1">Wie geht's weiter?</p>
          <div class="row no-gutters bg-white rounded-lg">
            <div class="col-md-6">
              <div class="d-flex-xl align-items-center mx-auto py-3 px-3" style="max-width: 362px;">
                <img class="d-inline-block my-2" src="img/myDesigns/icons/termin.svg" width="100" alt="Delivery">
                <p class="pt-1 text-dark font-size-sm">Wenn du mit unserem Preis zufrieden bist, ganz einfach Termin vereinbaren, über den Link in deiner E-Mail</p>
              </div>
              <hr class="d-md-none d-lg-none d-xl-none">
            </div>
            <div class="col-md-6">
              <div class="d-flex-xl align-items-center mx-auto py-3 px-3" style="max-width: 362px;">
                <img class="d-inline-block my-2" src="img/myDesigns/icons/exchange.svg" width="100" alt="Delivery">
                <p class="pt-1 text-dark font-size-sm">
                  Sind deine Angaben korrekt, zahlen wir dir ohne Verhandlung den angegebenen Preis und bauen deine Küche ab, ohne Stress!
                </p>
              </div>
            </div> 
          </div> 
        <p class="font-size-md text-center mb-1 mt-3">Mit freundlichen Grüßen</p>
        <p class="h6 text-center">wirkaufendeine-kueche.de</p>
      </div> 
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'evaluationComplete',
  components: {
  },
  data: function () { 
    return {
    }
  },
  computed: {
  },
  created: function () {
  },
  mounted: function () {
    window.scrollTo(0, 0); 
  },
  watch: {
  },
  methods: {
  }
}
</script>


<style scoped>
</style>